module.exports = __webpack_public_path__ + "img/common-acupoint-list.d05764b4.svg";